import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { LMModel } from '@form/model';

@Component({
  selector: 'lm-dropdown',
  standalone: false,
  templateUrl: 'lm-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [ ` :host { display: block; } ` ]
})

export class LMDropdownComponent {
  @Input() layoutObject: LMFormLayoutField | undefined;
  @Input() specFields: LMSpecFields | undefined;
  @Input() model: LMModel | undefined;
  @Input() mutexSpecField: LMSpecField | undefined;
  @Input() placeHolder: any;
  @Input() layoutInfo: LMFormLayoutInfo | undefined;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo | undefined;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo | undefined;
  @Input() parentCompoundFieldDisplayOnly: boolean | undefined;

  @HostBinding('class.wc-wrapper') useWC = false;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();
  @Output() errorOnMemberField: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
    // this.useWC = this.lmContextService.useWebComponents();
  }

  onFieldEvent($event: LMFieldEvent) {
    this.fieldEvent.emit($event);
  }

  onMemberFieldError(event: string) {
    this.errorOnMemberField.emit(event);
  }
}
